import script from "./MutatedEditPatient.vue?vue&type=script&lang=ts&setup=true"
export * from "./MutatedEditPatient.vue?vue&type=script&lang=ts&setup=true"

import "./MutatedEditPatient.vue?vue&type=style&index=0&id=2aa784f3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa784f3"]])

export default __exports__